import { z } from 'zod';
import { completedWorldcupResearchImportResponseSchema, completedWorldcupResearchImportSelectorSchema, } from './worldcup-research.js';
const nonEmptyStringSchema = z.string().trim().min(1);
export const adminDataQualityFixtureLimit = 25;
export const adminDataQualitySupportedFootballScopes = [
    {
        competitionCode: 'world_cup',
        season: 2026,
        label: 'FIFA World Cup 2026',
        providerCompetitionLabel: 'FIFA World Cup',
    },
];
const supportedScope = adminDataQualitySupportedFootballScopes[0];
export const adminDataQualitySupportedFootballScopeSchema = z.object({
    competitionCode: z.literal(supportedScope.competitionCode).default(supportedScope.competitionCode),
    season: z.coerce.number().pipe(z.literal(supportedScope.season)).default(supportedScope.season),
});
export const adminDataQualityImportSelectorSchema = completedWorldcupResearchImportSelectorSchema.extend({
    fixtureIds: z.array(z.coerce.number().int().positive()).max(adminDataQualityFixtureLimit).default([]),
    competitionCode: adminDataQualitySupportedFootballScopeSchema.shape.competitionCode,
    season: adminDataQualitySupportedFootballScopeSchema.shape.season,
    fixtureLimit: z.coerce.number().int().min(1).max(adminDataQualityFixtureLimit).default(adminDataQualityFixtureLimit),
});
export const adminDataQualityOperationKindSchema = z.enum(['execute', 'retry']);
export const adminDataQualityLifecycleStatusSchema = z.enum(['previewed', 'claimed', 'completed', 'failed']);
export const adminDataQualityPreviewRequestSchema = z.discriminatedUnion('operationKind', [
    z.object({
        operationKind: z.literal('execute'),
        selector: adminDataQualityImportSelectorSchema,
        maxProviderRequests: z.coerce.number().int().min(0).max(100).default(0),
        settleWindowMinutes: z.coerce.number().int().min(0).max(4320).default(120),
    }),
    z.object({
        operationKind: z.literal('retry'),
        priorRunId: nonEmptyStringSchema,
    }),
]);
export const adminDataQualityClaimRequestSchema = z.object({
    previewId: nonEmptyStringSchema,
});
export const adminDataQualityImportResponseSchema = completedWorldcupResearchImportResponseSchema.extend({
    previewId: nonEmptyStringSchema,
    importBatchId: nonEmptyStringSchema,
    operationKind: adminDataQualityOperationKindSchema,
    lifecycleStatus: adminDataQualityLifecycleStatusSchema,
    parentRunId: nonEmptyStringSchema.nullable(),
    retryableFixtureIds: z.array(z.number().int().positive()).max(adminDataQualityFixtureLimit),
});
